<template>
  <footer class="AppFooter">
    <div class="font-block">
      <p>
        <span>顺丰速运</span>
        &nbsp;
        <span
          >版权所有 Copyright © {{ new Date().getFullYear() }} sf-express.com
          Inc. All rights reserved.</span
        >
      </p>
      <p>
        <span>粤ICP</span>
        &nbsp;
        <span>备08034243号</span>
      </p>
    </div>
    <div class="rightFixed">
      <div id="svga" class="svgaBox" />
      <div id="svga" class="svgaBox" @click="openRobot">
        <img src="@/assets/images/robot.png" />
      </div>
      <div
        class="item icon-call"
        @mouseenter="contactUs('show')"
        @mouseleave="contactUs('hide')"
      >
        <div class="tit">联系我们</div>
      </div>
      <div v-show="gotop" class="scrollTops" @click="toTop">
        <i class="icon" />
      </div>
      <div
        v-if="contactFlag"
        class="contact-wrap"
        @mouseenter="contactUs('show')"
        @mouseleave="contactUs('hide')"
      >
        <ul class="list-contact">
          <li>
            <img
              :src="require('@/assets/images/icon_talk.svg')"
              alt=""
              class="icon"
            />
            <div class="area-txt">
              <div class="tit">
                <a
                  rel="noopener noreferrer"
                  class="track-btn-concact-side"
                  @click="contactAlert"
                  >合作咨询</a
                >
              </div>
              <div class="des">提交信息后，我们会有专人与您联络</div>
            </div>
          </li>
          <li>
            <img
              :src="require('@/assets/images/icon_call.svg')"
              alt=""
              class="icon"
            />
            <div class="area-txt">
              <div class="tit">咨询热线</div>
              <div class="des red">400-602-1111</div>
            </div>
          </li>
          <li>
            <img
              :src="require('@/assets/images/icon_email.svg')"
              alt=""
              class="icon"
            />
            <div class="area-txt">
              <div class="tit">邮箱</div>
              <div class="des red">laas@sfmail.sf-express.com</div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <concact ref="concacts" />
  </footer>
</template>

<script>
// import AIlogo from '/images/fengduoduo.svga'
// import AIlogo from '@/assets/images/fengduoduo.svga'
// const AIlogo = require('~@/assets/images/fengduoduo.svga')
import concact from "./Concact.vue";
let contactTimmer;
export default {
  name: "AppFooter",
  components: { concact },
  data() {
    return {
      gotop: false,
      contactFlag: false,
      detailsInfo: null,
      titles: "",
      widthBox: 1,
      // AIlogo: require('/images/fengduoduo.svga')
    };
  },
  mounted() {
    // console.log(this.AIlogo, '009')
    if (process.browser) {
      window.addEventListener("scroll", this.handleScroll, true);
      // const SVGA = window.SVGA
      // const player = new SVGA.Player('#svga')
      // const parser = new SVGA.Parser('#svga')
      // // 注意，这里必须是服务器地址，否则报错
      // parser.load(AIlogo, function (videoItem) {
      //   player.setVideoItem(videoItem)
      //   player.startAnimation()
      // })
    }
  },
  methods: {
    toTop() {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      const timeTop = setInterval(() => {
        document.body.scrollTop =
          document.documentElement.scrollTop =
          top -=
            50;
        if (top <= 0) {
          clearInterval(timeTop);
        }
      }, 10);
    },
    handleScroll() {
      const scrolltop =
        document.documentElement.scrollTop || document.body.scrollTop;
      scrolltop > 300 ? (this.gotop = true) : (this.gotop = false);
    },
    contactUs(action) {
      console.log(action, "0009");
      if (action === "show") {
        if (contactTimmer) {
          clearTimeout(contactTimmer);
        }
        this.contactFlag = true;
      } else {
        contactTimmer = setTimeout(() => {
          this.contactFlag = false;
        }, 100);
      }
    },
    contactAlert() {
      // this.$refs.concact.$emit('showForm')
      // this.$refs.concacts.showDialogs()
      window.open("https://dppj.sf-express.com/index");
    },
    openRobot() {
      // this.$refs.concact.$emit('showForm')
      // this.$refs.concacts.showDialogs()
      window.open(
        "https://fusionwork.sf-express.com/static-contact-desk/pc?appId=b05315483d6d4e2887599c51b211cbce&appSecret=974017d28cc848a094af9b25a7741d22"
      );
    },
  },
};
</script>

<style lang="less" scoped>
.AppFooter {
  position: relative;
  width: 100%;
  height: 120px;
  background: #444342;
  display: flex;
  justify-content: center;
  align-items: center;

  .font-block {
    text-align: center;

    p {
      height: 30px;
      font-size: 13px;
      color: #999999;
      text-align: center;
      line-height: 30px;
      font-weight: 400;
    }
  }
  .rightFixed {
    position: fixed;
    right: 2%;
    top: 50%;
    z-index: 8;
    text-align: center;
    margin-top: -20px;
    .sfLogo {
      width: 46px;
    }
    .svgaBox {
      width: 70px;
      height: 80px;
      margin: 0 -14px 0px -10px;
      position: relative;
    }
    .item {
      background: #fff;
      color: #666;
      // width: 24px;
      padding: 11px;
      border-radius: 23px;
      display: block;
      margin: 8px 0 12px;
      line-height: 1.1;
      font-size: 14px;
      cursor: pointer;
      position: relative;
      box-shadow: 0 0 5px -2px rgba(0, 0, 0, 0.2);
      transition: all linear 0.1s;
      img {
        vertical-align: top;
        width: 24px;
        height: 24px;
      }
      .tit {
        display: block;
        text-align: center;
        width: 24px;
        margin: 0;
        height: 0;
        overflow: hidden;
        font-size: 14px;
        line-height: 16px;
        height: 64px;
        margin: 8px 0;
        transition: all linear 0.1s;
      }
      &.icon-call {
        &::before {
          content: "";
          display: block;
          width: 24px;
          height: 24px;
          background: url("~@/assets/images/call_icon_2.svg") center center
            no-repeat;
          background-size: contain;
        }
        &:hover {
          &::before {
            background: url("~@/assets/images/call_icon.svg") center center
              no-repeat;
            background-size: contain;
          }
        }
      }
      &:hover {
        background: #d41624;
        color: #fff;
        // width: 24px;
        .tit {
          height: 64px;
          margin: 8px 0;
        }
      }
    }
    // .item-qrcode{
    //   width: 16px;
    //   height: 16px;
    //   padding: 15px;
    //   margin-bottom: 8px;
    //   border-radius: 50%;
    //   position: relative;
    //   background: #FFFFFF;
    //   box-shadow: 0 0 5px -2px rgba(0,0,0,.2);
    //   i.icon-qrcode{
    //     display: block;
    //     width: 16px;
    //     height: 16px;
    //     background: url('@/assets/qr_code_normal_icon.png') center center no-repeat;
    //     background-size: contain;
    //   }
    //   .area-qrcode{
    //     display: none;
    //     position: absolute;
    //     right: 100%;
    //     background: #fff;
    //     padding: 10px;
    //     width: 200px;
    //     top: 50%;
    //     transform: translate(0,-80%);
    //     box-shadow: 0 0 5px 2px rgba(0,0,0,.07);
    //     margin-right: 20px;
    //     border-radius: 4px;
    //     &::after{
    //       content: '';
    //       position: absolute;
    //       left: 100%;
    //       top: 80%;
    //       margin-top: -8px;
    //       width: 0;
    //       height: 0;
    //       border: 8px dashed;
    //       border-color: transparent transparent transparent #fff;
    //     }
    //     p{
    //       font-size: 14px;
    //       color: #D41024;
    //       line-height: 14px;
    //       margin-top: 8px;
    //     }
    //     img{
    //       display: block;
    //       width: 200px;
    //       height: 200px;
    //     }
    //   }
    //   &:hover{
    //     i.icon-qrcode{
    //       background: url('@/assets/qr_code_hover_icon.png') center center no-repeat;
    //       background-size: contain;
    //     }
    //     .area-qrcode{
    //       display: block;
    //     }
    //   }

    // }
    .scrollTops {
      background: #fff;
      display: block;
      padding: 15px;
      width: 16px;
      height: 16px;
      box-shadow: 0 0 5px -2px rgba(0, 0, 0, 0.2);
      cursor: pointer;
      position: relative;
      transition: 0.5s;
      border-radius: 50%;
      i.icon {
        width: 16px;
        height: 16px;
        display: block;
        background: url("~@/assets/images/top_normal_icon.png") center center
          no-repeat;
        background-size: contain;
        &:hover {
          background: url("~@/assets/images/top_hover_icon.png") center center
            no-repeat;
          background-size: contain;
        }
      }
    }
    .contact-wrap {
      position: absolute;
      right: 100%;
      top: 50px;
      margin-right: 12px;
      background: #fff;
      box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.07);
      padding: 0 24px;
      width: 320px;
      border-radius: 4px;
      &::after {
        content: "";
        display: block;
        position: absolute;
        left: 100%;
        top: 30px;
        width: 0;
        height: 0;
        border: 5px solid transparent;
        border-left: 5px solid #fff;
      }
      .list-contact {
        li {
          margin: 24px 0;
          img {
            width: 20px;
            height: 20px;
            float: left;
            margin-right: 12px;
          }
          .area-txt {
            text-align: left;
            line-height: 1.5;
            overflow: hidden;
            .tit {
              font-size: 14px;
              font-weight: bold;
              line-height: 14px;
              a::after {
                content: "";
                display: inline-block;
                width: 8px;
                height: 8px;
                border-top: 1px solid #d41624;
                border-right: 1px solid #d41624;
                transform: translate(0, -1px) rotate(45deg);
                margin-left: 5px;
              }
              .track-btn-concact-side {
                color: #333;
                cursor: pointer;
              }
            }
            .des {
              font-size: 14px;
              line-height: 16px;
              margin-top: 12px;
              &.red {
                color: #d41024;
              }
            }
          }
        }
      }
    }
  }
}
</style>
